import { inject, observer } from 'mobx-react'
import React from 'react'

@inject('sidebarStore', 'photoStore', 'store', 'illustrationStore', 'elementStore', 'templateStore') @observer
class SlideSearch extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      searchValue: ''
    }
    this._searchDebounce = null
  }

  handleChange(e){
    const { value } = e.target
    this.setState({ searchValue: value })
    this.props.sidebarStore.changeSearchValue(value)
  }

  componentDidMount(){
    this.setState({
      searchValue: this.props.sidebarStore.searchValue
    })
  }

  async handleKeyPress(e){
    const { value } = e.target
    const { 
      sidebarStore,
      photoStore,
      templateStore,
      illustrationStore,
      elementStore
    } = this.props
    const activeSlide = sidebarStore.items.find(({ active }) => active)
    clearTimeout(this._searchDebounce)
    this._searchDebounce = setTimeout(async () => {
      switch(activeSlide.id){
        case 'templates':
          if(this.props.store.isTeam){
            await Promise.all([
              this.props.templateStore.populateUserDesigns(value, this.props.store.teamDetails._id),
              templateStore.populateUserDesigns(value)
            ])
          }else{
            await templateStore.populateUserDesigns(value)
          }
          break
        case 'photos':
          photoStore.setTerm(value)
          await photoStore.searchImages()
          break
        case 'gifs':
          await elementStore.searchByTerm(value, this.props.sidebarStore.gifsOnly, this.props.sidebarStore.stickersOnly)
          break
        case 'illustrations':
          await illustrationStore.fetchCollections(value)
          break
        case 'text':
          break
        case 'draw':
          break
        default:
          break
      }
    }, 500)
  }

  componentDidUpdate(){
    if(this.state.searchValue !== this.props.searchValue){
      this.setState({ searchValue: this.props.searchValue })
      clearTimeout(this._searchDebounce)
    }
  }

  render () {
    return (
      <div className="slide-search">
        <input
          type='text' 
          placeholder='Search'
          className='form-control slide-search__input' 
          value={this.state.searchValue}
          onChange={e => this.handleChange(e)}
          onKeyUp={this.handleKeyPress.bind(this)} 
        />
      </div>
    )
  }
}

export default SlideSearch
